import * as Query from '@web/contracts/Query';
export const Keys: Query.List.Query = {
  records: 'list-records',
  content: 'list-content',
  'crm-content': 'list-crm-content',
  search: 'list-search',
  'ids-by-profiles': 'list-ids-by-profiles',
};
